import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#e8b86d' },
    secondary: { main: '#7dd3c0' },
    background: {
      default: '#0a0908',
      paper: 'rgba(255, 255, 255, 0.035)',
    },
    text: {
      primary: 'rgba(255, 255, 255, 0.93)',
      secondary: 'rgba(255, 255, 255, 0.62)',
    },
    divider: 'rgba(255, 255, 255, 0.08)',
  },
  typography: {
    fontFamily:
      '"Instrument Sans", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    h1: { fontWeight: 650, letterSpacing: '-0.035em', lineHeight: 1.08 },
    h2: { fontWeight: 600, letterSpacing: '-0.02em' },
    h5: { fontWeight: 600 },
    overline: { letterSpacing: '0.14em', fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(255, 255, 255, 0.08)',
          backgroundImage:
            'linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0) 100%)',
        },
      },
    },
  },
});
